(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["naja"] = factory();
	else
		root["naja"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 3);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * @author Toru Nagashima
 * @copyright 2015 Toru Nagashima. All rights reserved.
 * See LICENSE file in root directory for full license.
 */


/**
 * Creates a unique key.
 *
 * @param {string} name - A name to create.
 * @returns {symbol|string} Generated unique key.
 * @private
 */
var createUniqueKey = module.exports.createUniqueKey = (
    typeof Symbol !== "undefined" ? Symbol : //eslint-disable-line no-undef
    /* otherwise */ function createUniqueKey(name) {
        return "[[" + name + "_" + Math.random().toFixed(8).slice(2) + "]]"
    }
)

/**
 * Checks whether the given value is a non-null object or not.
 *
 * @param {any} x - The value to be check.
 * @returns {boolean} `true` if the value is a non-null object.
 * @private
 */
var isObject = module.exports.isObject = function isObject(x) {
    return typeof x === "object" && x !== null
}

/**
 * The key of listeners.
 *
 * @type {symbol|string}
 * @private
 */
module.exports.LISTENERS = createUniqueKey("listeners")

/**
 * A value of kind for listeners which are registered in the capturing phase.
 *
 * @type {number}
 * @private
 */
module.exports.CAPTURE = 1

/**
 * A value of kind for listeners which are registered in the bubbling phase.
 *
 * @type {number}
 * @private
 */
module.exports.BUBBLE = 2

/**
 * A value of kind for listeners which are registered as an attribute.
 *
 * @type {number}
 * @private
 */
module.exports.ATTRIBUTE = 3

/**
 * @typedef object ListenerNode
 * @property {function} listener - A listener function.
 * @property {number} kind - The kind of the listener.
 * @property {ListenerNode|null} next - The next node.
 *      If this node is the last, this is `null`.
 */

/**
 * Creates a node of singly linked list for a list of listeners.
 *
 * @param {function} listener - A listener function.
 * @param {number} kind - The kind of the listener.
 * @param {object} [options] - The option object.
 * @param {boolean} [options.once] - The flag to remove the listener at the first call.
 * @param {boolean} [options.passive] - The flag to ignore `event.preventDefault` method.
 * @returns {ListenerNode} The created listener node.
 */
module.exports.newNode = function newNode(listener, kind, options) {
    var obj = isObject(options)

    return {
        listener: listener,
        kind: kind,
        once: obj && Boolean(options.once),
        passive: obj && Boolean(options.passive),
        next: null,
    }
}


/***/ }),
/* 1 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * @author Toru Nagashima
 * @copyright 2015 Toru Nagashima. All rights reserved.
 * See LICENSE file in root directory for full license.
 */


//------------------------------------------------------------------------------
// Requirements
//------------------------------------------------------------------------------

/*globals window */

var Commons = __webpack_require__(0)
var CustomEventTarget = __webpack_require__(13)
var EventWrapper = __webpack_require__(14)
var isObject = Commons.isObject
var LISTENERS = Commons.LISTENERS
var CAPTURE = Commons.CAPTURE
var BUBBLE = Commons.BUBBLE
var ATTRIBUTE = Commons.ATTRIBUTE
var newNode = Commons.newNode
var defineCustomEventTarget = CustomEventTarget.defineCustomEventTarget
var createEventWrapper = EventWrapper.createEventWrapper
var STOP_IMMEDIATE_PROPAGATION_FLAG = EventWrapper.STOP_IMMEDIATE_PROPAGATION_FLAG
var PASSIVE_LISTENER_FLAG = EventWrapper.PASSIVE_LISTENER_FLAG

//------------------------------------------------------------------------------
// Constants
//------------------------------------------------------------------------------

/**
 * A flag which shows there is the native `EventTarget` interface object.
 *
 * @type {boolean}
 * @private
 */
var HAS_EVENTTARGET_INTERFACE = (
    typeof window !== "undefined" &&
    typeof window.EventTarget !== "undefined"
)

//------------------------------------------------------------------------------
// Public Interface
//------------------------------------------------------------------------------

/**
 * An implementation for `EventTarget` interface.
 *
 * @constructor
 * @public
 */
var EventTarget = module.exports = function EventTarget() {
    if (this instanceof EventTarget) {
        // this[LISTENERS] is a Map.
        // Its key is event type.
        // Its value is ListenerNode object or null.
        //
        // interface ListenerNode {
        //     var listener: Function
        //     var kind: CAPTURE|BUBBLE|ATTRIBUTE
        //     var next: ListenerNode|null
        // }
        Object.defineProperty(this, LISTENERS, {value: Object.create(null)})
    }
    else if (arguments.length === 1 && Array.isArray(arguments[0])) {
        return defineCustomEventTarget(EventTarget, arguments[0])
    }
    else if (arguments.length > 0) {
        var types = Array(arguments.length)
        for (var i = 0; i < arguments.length; ++i) {
            types[i] = arguments[i]
        }

        // To use to extend with attribute listener properties.
        // e.g.
        //     class MyCustomObject extends EventTarget("message", "error") {
        //         //...
        //     }
        return defineCustomEventTarget(EventTarget, types)
    }
    else {
        throw new TypeError("Cannot call a class as a function")
    }
}

EventTarget.prototype = Object.create(
    (HAS_EVENTTARGET_INTERFACE ? window.EventTarget : Object).prototype,
    {
        constructor: {
            value: EventTarget,
            writable: true,
            configurable: true,
        },

        addEventListener: {
            value: function addEventListener(type, listener, options) {
                if (listener == null) {
                    return false
                }
                if (typeof listener !== "function" && typeof listener !== "object") {
                    throw new TypeError("\"listener\" is not an object.")
                }

                var capture = isObject(options) ? Boolean(options.capture) : Boolean(options)
                var kind = (capture ? CAPTURE : BUBBLE)
                var node = this[LISTENERS][type]
                if (node == null) {
                    this[LISTENERS][type] = newNode(listener, kind, options)
                    return true
                }

                var prev = null
                while (node != null) {
                    if (node.listener === listener && node.kind === kind) {
                        // Should ignore a duplicated listener.
                        return false
                    }
                    prev = node
                    node = node.next
                }

                prev.next = newNode(listener, kind, options)
                return true
            },
            configurable: true,
            writable: true,
        },

        removeEventListener: {
            value: function removeEventListener(type, listener, options) {
                if (listener == null) {
                    return false
                }

                var capture = isObject(options) ? Boolean(options.capture) : Boolean(options)
                var kind = (capture ? CAPTURE : BUBBLE)
                var prev = null
                var node = this[LISTENERS][type]
                while (node != null) {
                    if (node.listener === listener && node.kind === kind) {
                        if (prev == null) {
                            this[LISTENERS][type] = node.next
                        }
                        else {
                            prev.next = node.next
                        }
                        return true
                    }

                    prev = node
                    node = node.next
                }

                return false
            },
            configurable: true,
            writable: true,
        },

        dispatchEvent: {
            value: function dispatchEvent(event) {
                // If listeners aren't registered, terminate.
                var type = event.type
                var node = this[LISTENERS][type]
                if (node == null) {
                    return true
                }

                // Since we cannot rewrite several properties, so wrap object.
                var wrapped = createEventWrapper(event, this)

                // This doesn't process capturing phase and bubbling phase.
                // This isn't participating in a tree.
                var prev = null
                while (node != null) {
                    // Remove this listener if it's once
                    if (node.once) {
                        if (prev == null) {
                            this[LISTENERS][type] = node.next
                        }
                        else {
                            prev.next = node.next
                        }
                    }
                    else {
                        prev = node
                    }

                    // Call this listener
                    wrapped[PASSIVE_LISTENER_FLAG] = node.passive
                    if (typeof node.listener === "function") {
                        node.listener.call(this, wrapped)
                    }
                    else if (node.kind !== ATTRIBUTE && typeof node.listener.handleEvent === "function") {
                        node.listener.handleEvent(wrapped)
                    }

                    // Break if `event.stopImmediatePropagation` was called.
                    if (wrapped[STOP_IMMEDIATE_PROPAGATION_FLAG]) {
                        break
                    }

                    node = node.next
                }

                return !wrapped.defaultPrevented
            },
            configurable: true,
            writable: true,
        },
    }
)


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(4);


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Naja = __webpack_require__(5);

var _Naja2 = _interopRequireDefault(_Naja);

var _AbortExtension = __webpack_require__(21);

var _AbortExtension2 = _interopRequireDefault(_AbortExtension);

var _UniqueExtension = __webpack_require__(22);

var _UniqueExtension2 = _interopRequireDefault(_UniqueExtension);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var naja = new _Naja2.default();
naja.registerExtension(_AbortExtension2.default);
naja.registerExtension(_UniqueExtension2.default);

exports.default = naja;

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _qwest = __webpack_require__(6);

var _qwest2 = _interopRequireDefault(_qwest);

var _objectAssign = __webpack_require__(12);

var _objectAssign2 = _interopRequireDefault(_objectAssign);

var _eventTargetShim = __webpack_require__(2);

var _eventTargetShim2 = _interopRequireDefault(_eventTargetShim);

var _UIHandler = __webpack_require__(15);

var _UIHandler2 = _interopRequireDefault(_UIHandler);

var _FormsHandler = __webpack_require__(16);

var _FormsHandler2 = _interopRequireDefault(_FormsHandler);

var _RedirectHandler = __webpack_require__(17);

var _RedirectHandler2 = _interopRequireDefault(_RedirectHandler);

var _SnippetHandler = __webpack_require__(18);

var _SnippetHandler2 = _interopRequireDefault(_SnippetHandler);

var _HistoryHandler = __webpack_require__(19);

var _HistoryHandler2 = _interopRequireDefault(_HistoryHandler);

var _ScriptLoader = __webpack_require__(20);

var _ScriptLoader2 = _interopRequireDefault(_ScriptLoader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Naja = function (_EventTarget) {
	_inherits(Naja, _EventTarget);

	function Naja(uiHandler, redirectHandler, snippetHandler, formsHandler, historyHandler, scriptLoader) {
		_classCallCheck(this, Naja);

		var _this = _possibleConstructorReturn(this, (Naja.__proto__ || Object.getPrototypeOf(Naja)).call(this));

		_this.initialized = false;
		_this.uiHandler = null;
		_this.redirectHandler = null;
		_this.snippetHandler = null;
		_this.formsHandler = null;
		_this.historyHandler = null;
		_this.scriptLoader = null;
		_this.extensions = [];
		_this.defaultOptions = {};

		_this.uiHandler = uiHandler ? new uiHandler(_this) : new _UIHandler2.default(_this);
		_this.redirectHandler = redirectHandler ? new redirectHandler(_this) : new _RedirectHandler2.default(_this);
		_this.snippetHandler = snippetHandler ? new snippetHandler(_this) : new _SnippetHandler2.default(_this);
		_this.formsHandler = formsHandler ? new formsHandler(_this) : new _FormsHandler2.default(_this);
		_this.historyHandler = historyHandler ? new historyHandler(_this) : new _HistoryHandler2.default(_this);
		_this.scriptLoader = scriptLoader ? new scriptLoader(_this) : new _ScriptLoader2.default(_this);
		return _this;
	}

	_createClass(Naja, [{
		key: 'registerExtension',
		value: function registerExtension(extensionClass) {
			for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
				args[_key - 1] = arguments[_key];
			}

			this.extensions.push([extensionClass, args]);
		}
	}, {
		key: 'initialize',
		value: function initialize() {
			var _this2 = this;

			var defaultOptions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

			if (this.initialized) {
				throw new Error('Cannot initialize Naja, it is already initialized.');
			}

			this.defaultOptions = defaultOptions;
			this.extensions = this.extensions.map(function (_ref) {
				var _ref2 = _slicedToArray(_ref, 2),
				    extensionClass = _ref2[0],
				    args = _ref2[1];

				return new (Function.prototype.bind.apply(extensionClass, [null].concat([_this2], _toConsumableArray(args))))();
			});

			this.fireEvent('init', { defaultOptions: defaultOptions });
			this.initialized = true;
			this.load();
		}
	}, {
		key: 'load',
		value: function load() {
			this.fireEvent('load');
		}
	}, {
		key: 'fireEvent',
		value: function fireEvent(type) {
			var args = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

			var evt = (0, _objectAssign2.default)(args, { type: type, cancelable: true });
			return this.dispatchEvent(evt);
		}
	}, {
		key: 'makeRequest',
		value: function makeRequest(method, url, data, options) {
			var _this3 = this;

			var defaultOptions = {
				dataType: 'post',
				responseType: 'auto'
			};

			options = (0, _objectAssign2.default)({}, defaultOptions, this.defaultOptions, options || {});

			var currentXhr = void 0;
			var beforeCallback = function beforeCallback(xhr) {
				currentXhr = xhr;

				// abort request if beforeEvent.preventDefault() is called
				if (!_this3.fireEvent('before', { xhr: xhr, method: method, url: url, data: data, options: options })) {
					xhr.abort();
				}

				// qwest does not handle response at all if the request is aborted
				xhr.addEventListener('abort', function () {
					_this3.fireEvent('abort', { xhr: xhr });
					_this3.fireEvent('complete', { error: new Error('Request aborted'), xhr: xhr, response: null, options: options });
				});
			};

			var request = _qwest2.default.map(method, url, data, options, beforeCallback).then(function (xhr, response) {
				_this3.fireEvent('success', { xhr: xhr, response: response, options: options });
				_this3.fireEvent('complete', { error: null, xhr: xhr, response: response, options: options });
				_this3.load();

				return response;
			}).catch(function (error, xhr, response) {
				_this3.fireEvent('error', { error: error, xhr: xhr, response: response, options: options });
				_this3.fireEvent('complete', { error: error, xhr: xhr, response: response, options: options });
				_this3.load();

				throw error;
			});

			this.fireEvent('start', { request: request, xhr: currentXhr });
			return request;
		}
	}]);

	return Naja;
}(_eventTargetShim2.default);

exports.default = Naja;

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

/*! qwest 4.5.0 (https://github.com/pyrsmk/qwest) */

module.exports = function() {

    var global = typeof window != 'undefined' ? window : self,
        pinkyswear = __webpack_require__(7),
        jparam = __webpack_require__(11),
        defaultOptions = {},
        // Default response type for XDR in auto mode
        defaultXdrResponseType = 'json',
        // Default data type
        defaultDataType = 'post',
        // Variables for limit mechanism
        limit = null,
        requests = 0,
        request_stack = [],
        // Get XMLHttpRequest object
        getXHR = global.XMLHttpRequest? function(){
            return new global.XMLHttpRequest();
        }: function(){
            return new ActiveXObject('Microsoft.XMLHTTP');
        },
        // Guess XHR version
        xhr2 = (getXHR().responseType===''),

    // Core function
    qwest = function(method, url, data, options, before) {
        // Format
        method = method.toUpperCase();
        data = data === undefined ? null : data;
        options = options || {};
        for(var name in defaultOptions) {
            if(!(name in options)) {
                if(typeof defaultOptions[name] == 'object' && typeof options[name] == 'object') {
                    for(var name2 in defaultOptions[name]) {
                        options[name][name2] = defaultOptions[name][name2];
                    }
                }
                else {
                    options[name] = defaultOptions[name];
                }
            }
        }

        // Define variables
        var nativeResponseParsing = false,
            crossOrigin,
            xhr,
            xdr = false,
            timeout,
            aborted = false,
            attempts = 0,
            headers = {},
            mimeTypes = {
                text: '*/*',
                xml: 'text/xml',
                json: 'application/json',
                post: 'application/x-www-form-urlencoded',
                document: 'text/html'
            },
            accept = {
                text: '*/*',
                xml: 'application/xml; q=1.0, text/xml; q=0.8, */*; q=0.1',
                json: 'application/json; q=1.0, text/*; q=0.8, */*; q=0.1'
            },
            i, j,
            response,
            sending = false,

        // Create the promise
        promise = pinkyswear(function(pinky) {
            pinky.abort = function() {
                if(!aborted) {
                    if(xhr && xhr.readyState != 4) { // https://stackoverflow.com/questions/7287706/ie-9-javascript-error-c00c023f
                        xhr.abort();
                    }
                    if(sending) {
                        --requests;
                        sending = false;
                    }
                    aborted = true;
                }
            };
            pinky.send = function() {
                // Prevent further send() calls
                if(sending) {
                    return;
                }
                // Reached request limit, get out!
                if(requests == limit) {
                    request_stack.push(pinky);
                    return;
                }
                // Verify if the request has not been previously aborted
                if(aborted) {
                    if(request_stack.length) {
                        request_stack.shift().send();
                    }
                    return;
                }
                // The sending is running
                ++requests;
                sending = true;
                // Get XHR object
                xhr = getXHR();
                if(crossOrigin) {
                    if(!('withCredentials' in xhr) && global.XDomainRequest) {
                        xhr = new XDomainRequest(); // CORS with IE8/9
                        xdr = true;
                        if(method != 'GET' && method != 'POST') {
                            method = 'POST';
                        }
                    }
                }
                // Open connection
                if(xdr) {
                    xhr.open(method, url);
                }
                else {
                    xhr.open(method, url, options.async, options.user, options.password);
                    if(xhr2 && options.async) {
                        xhr.withCredentials = options.withCredentials;
                    }
                }
                // Set headers
                if(!xdr) {
                    for(var i in headers) {
                        if(headers[i]) {
                            xhr.setRequestHeader(i, headers[i]);
                        }
                    }
                }
                // Verify if the response type is supported by the current browser
                if(xhr2 && options.responseType != 'auto') {
                    try {
                        xhr.responseType = options.responseType;
                        nativeResponseParsing = (xhr.responseType == options.responseType);
                    }
                    catch(e) {}
                }
                // Plug response handler
                if(xhr2 || xdr) {
                    xhr.onload = handleResponse;
                    xhr.onerror = handleError;
                    // http://cypressnorth.com/programming/internet-explorer-aborting-ajax-requests-fixed/
                    if(xdr) {
                        xhr.onprogress = function() {};
                    }
                }
                else {
                    xhr.onreadystatechange = function() {
                        if(xhr.readyState == 4) {
                            handleResponse();
                        }
                    };
                }
                // Plug timeout
                if(options.async) {
                    if('timeout' in xhr) {
                        xhr.timeout = options.timeout;
                        xhr.ontimeout = handleTimeout;
                    }
                    else {
                        timeout = setTimeout(handleTimeout, options.timeout);
                    }
                }
                // http://cypressnorth.com/programming/internet-explorer-aborting-ajax-requests-fixed/
                else if(xdr) {
                    xhr.ontimeout = function() {};
                }
                // Override mime type to ensure the response is well parsed
                if(options.responseType != 'auto' && 'overrideMimeType' in xhr) {
                    xhr.overrideMimeType(mimeTypes[options.responseType]);
                }
                // Run 'before' callback
                if(before) {
                    before(xhr);
                }
                // Send request
                if(xdr) {
                    // https://developer.mozilla.org/en-US/docs/Web/API/XDomainRequest
                    setTimeout(function() {
                        xhr.send(method != 'GET'? data : null);
                    }, 0);
                }
                else {
                    xhr.send(method != 'GET' ? data : null);
                }
            };
            return pinky;
        }),

        // Handle the response
        handleResponse = function() {
            var i, responseType;
            // Stop sending state
            sending = false;
            clearTimeout(timeout);
            // Launch next stacked request
            if(request_stack.length) {
                request_stack.shift().send();
            }
            // Verify if the request has not been previously aborted
            if(aborted) {
                return;
            }
            // Decrease the number of requests
            --requests;
            // Handle response
            try{
                // Process response
                if(nativeResponseParsing) {
                    if('response' in xhr && xhr.response === null) {
                        throw 'The request response is empty';
                    }
                    response = xhr.response;
                }
                else {
                    // Guess response type
                    responseType = options.responseType;
                    if(responseType == 'auto') {
                        if(xdr) {
                            responseType = defaultXdrResponseType;
                        }
                        else {
                            var ct = xhr.getResponseHeader('Content-Type') || '';
                            if(ct.indexOf(mimeTypes.json)>-1) {
                                responseType = 'json';
                            }
                            else if(ct.indexOf(mimeTypes.xml) > -1) {
                                responseType = 'xml';
                            }
                            else {
                                responseType = 'text';
                            }
                        }
                    }
                    // Handle response type
                    switch(responseType) {
                        case 'json':
                            if(xhr.responseText.length) {
                                try {
                                    if('JSON' in global) {
                                        response = JSON.parse(xhr.responseText);
                                    }
                                    else {
                                        response = new Function('return (' + xhr.responseText + ')')();
                                    }
                                }
                                catch(e) {
                                    throw "Error while parsing JSON body : "+e;
                                }
                            }
                            break;
                        case 'xml':
                            // Based on jQuery's parseXML() function
                            try {
                                // Standard
                                if(global.DOMParser) {
                                    response = (new DOMParser()).parseFromString(xhr.responseText,'text/xml');
                                }
                                // IE<9
                                else {
                                    response = new ActiveXObject('Microsoft.XMLDOM');
                                    response.async = 'false';
                                    response.loadXML(xhr.responseText);
                                }
                            }
                            catch(e) {
                                response = undefined;
                            }
                            if(!response || !response.documentElement || response.getElementsByTagName('parsererror').length) {
                                throw 'Invalid XML';
                            }
                            break;
                        default:
                            response = xhr.responseText;
                    }
                }
                // Late status code verification to allow passing data when, per example, a 409 is returned
                // --- https://stackoverflow.com/questions/10046972/msie-returns-status-code-of-1223-for-ajax-request
                if('status' in xhr && !/^2|1223/.test(xhr.status)) {
                    throw xhr.status + ' (' + xhr.statusText + ')';
                }
                // Fulfilled
                promise(true, [xhr, response]);
            }
            catch(e) {
                // Rejected
                promise(false, [e, xhr, response]);
            }
        },

        // Handle errors
        handleError = function(message) {
            if(!aborted) {
                message = typeof message == 'string' ? message : 'Connection aborted';
                promise.abort();
                promise(false, [new Error(message), xhr, null]);
            }
        },

        // Handle timeouts
        handleTimeout = function() {
            if(!aborted) {
                if(!options.attempts || ++attempts != options.attempts) {
                    xhr.abort();
                    sending = false;
                    promise.send();
                }
                else {
                    handleError('Timeout (' + url + ')');
                }
            }
        };

        // Normalize options
        options.async = 'async' in options ? !!options.async : true;
        options.cache = 'cache' in options ? !!options.cache : false;
        options.dataType = 'dataType' in options ? options.dataType.toLowerCase() : defaultDataType;
        options.responseType = 'responseType' in options ? options.responseType.toLowerCase() : 'auto';
        options.user = options.user || '';
        options.password = options.password || '';
        options.withCredentials = !!options.withCredentials;
        options.timeout = 'timeout' in options ? parseInt(options.timeout, 10) : 30000;
        options.attempts = 'attempts' in options ? parseInt(options.attempts, 10) : 1;

        // Guess if we're dealing with a cross-origin request
        i = url.match(/\/\/(.+?)\//);
        crossOrigin = i && (i[1] ? i[1] != location.host : false);

        // Prepare data
        if('ArrayBuffer' in global && data instanceof ArrayBuffer) {
            options.dataType = 'arraybuffer';
        }
        else if('Blob' in global && data instanceof Blob) {
            options.dataType = 'blob';
        }
        else if('Document' in global && data instanceof Document) {
            options.dataType = 'document';
        }
        else if('FormData' in global && data instanceof FormData) {
            options.dataType = 'formdata';
        }
        if(data !== null) {
            switch(options.dataType) {
                case 'json':
                    data = JSON.stringify(data);
                    break;
                case 'post':
                case 'queryString':
                    data = jparam(data);
            }
        }

        // Prepare headers
        if(options.headers) {
            var format = function(match,p1,p2) {
                return p1 + p2.toUpperCase();
            };
            for(i in options.headers) {
                headers[i.replace(/(^|-)([^-])/g,format)] = options.headers[i];
            }
        }
        if(!('Content-Type' in headers) && method!='GET') {
            if(options.dataType in mimeTypes) {
                if(mimeTypes[options.dataType]) {
                    headers['Content-Type'] = mimeTypes[options.dataType];
                }
            }
        }
        if(!headers.Accept) {
            headers.Accept = (options.responseType in accept) ? accept[options.responseType] : '*/*';
        }
        if(!crossOrigin && !('X-Requested-With' in headers)) { // (that header breaks in legacy browsers with CORS)
            headers['X-Requested-With'] = 'XMLHttpRequest';
        }
        if(!options.cache && !('Cache-Control' in headers)) {
            headers['Cache-Control'] = 'no-cache';
        }

        // Prepare URL
        if((method == 'GET' || options.dataType == 'queryString') && data && typeof data == 'string') {
            url += (/\?/.test(url)?'&':'?') + data;
        }

        // Start the request
        if(options.async) {
            promise.send();
        }

        // Return promise
        return promise;

    };

    // Define external qwest object
    var getNewPromise = function(q) {
            // Prepare
            var promises = [],
                loading = 0,
                values = [];
            // Create a new promise to handle all requests
            return pinkyswear(function(pinky) {
                // Basic request method
                var method_index = -1,
                    createMethod = function(method) {
                        return function(url, data, options, before) {
                            var index = ++method_index;
                            ++loading;
                            promises.push(qwest(method, pinky.base + url, data, options, before).then(function(xhr, response) {
                                values[index] = arguments;
                                if(!--loading) {
                                    pinky(true, values.length == 1 ? values[0] : [values]);
                                }
                            }, function() {
                                pinky(false, arguments);
                            }));
                            return pinky;
                        };
                    };
                // Define external API
                pinky.get = createMethod('GET');
                pinky.post = createMethod('POST');
                pinky.put = createMethod('PUT');
                pinky['delete'] = createMethod('DELETE');
                pinky['catch'] = function(f) {
                    return pinky.then(null, f);
                };
                pinky.complete = function(f) {
                    var func = function() {
                        f(); // otherwise arguments will be passed to the callback
                    };
                    return pinky.then(func, func);
                };
                pinky.map = function(type, url, data, options, before) {
                    return createMethod(type.toUpperCase()).call(this, url, data, options, before);
                };
                // Populate methods from external object
                for(var prop in q) {
                    if(!(prop in pinky)) {
                        pinky[prop] = q[prop];
                    }
                }
                // Set last methods
                pinky.send = function() {
                    for(var i=0, j=promises.length; i<j; ++i) {
                        promises[i].send();
                    }
                    return pinky;
                };
                pinky.abort = function() {
                    for(var i=0, j=promises.length; i<j; ++i) {
                        promises[i].abort();
                    }
                    return pinky;
                };
                return pinky;
            });
        },
        q = {
            base: '',
            get: function() {
                return getNewPromise(q).get.apply(this, arguments);
            },
            post: function() {
                return getNewPromise(q).post.apply(this, arguments);
            },
            put: function() {
                return getNewPromise(q).put.apply(this, arguments);
            },
            'delete': function() {
                return getNewPromise(q)['delete'].apply(this, arguments);
            },
            map: function() {
                return getNewPromise(q).map.apply(this, arguments);
            },
            xhr2: xhr2,
            limit: function(by) {
                limit = by;
                return q;
            },
            setDefaultOptions: function(options) {
                defaultOptions = options;
                return q;
            },
            setDefaultXdrResponseType: function(type) {
                defaultXdrResponseType = type.toLowerCase();
                return q;
            },
            setDefaultDataType: function(type) {
                defaultDataType = type.toLowerCase();
                return q;
            },
            getOpenRequests: function() {
                return requests;
            }
        };

    return q;

}();


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(setImmediate, process) {var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*
 * PinkySwear.js 2.2.2 - Minimalistic implementation of the Promises/A+ spec
 * 
 * Public Domain. Use, modify and distribute it any way you like. No attribution required.
 *
 * NO WARRANTY EXPRESSED OR IMPLIED. USE AT YOUR OWN RISK.
 *
 * PinkySwear is a very small implementation of the Promises/A+ specification. After compilation with the
 * Google Closure Compiler and gzipping it weighs less than 500 bytes. It is based on the implementation for 
 * Minified.js and should be perfect for embedding. 
 *
 *
 * PinkySwear has just three functions.
 *
 * To create a new promise in pending state, call pinkySwear():
 *         var promise = pinkySwear();
 *
 * The returned object has a Promises/A+ compatible then() implementation:
 *          promise.then(function(value) { alert("Success!"); }, function(value) { alert("Failure!"); });
 *
 *
 * The promise returned by pinkySwear() is a function. To fulfill the promise, call the function with true as first argument and
 * an optional array of values to pass to the then() handler. By putting more than one value in the array, you can pass more than one
 * value to the then() handlers. Here an example to fulfill a promsise, this time with only one argument: 
 *         promise(true, [42]);
 *
 * When the promise has been rejected, call it with false. Again, there may be more than one argument for the then() handler:
 *         promise(true, [6, 6, 6]);
 *         
 * You can obtain the promise's current state by calling the function without arguments. It will be true if fulfilled,
 * false if rejected, and otherwise undefined.
 * 		   var state = promise(); 
 * 
 * https://github.com/timjansen/PinkySwear.js
 */
(function (root, factory) {
	if (true) {
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else if (typeof module === 'object' && module.exports) {
		module.exports = factory();
	} else {
		root.pinkySwear = factory();
	}
}(this, function() {
	var undef;

	function isFunction(f) {
		return typeof f == 'function';
	}
	function isObject(f) {
		return typeof f == 'object';
	}
	function defer(callback) {
		if (typeof setImmediate != 'undefined')
			setImmediate(callback);
		else if (typeof process != 'undefined' && process['nextTick'])
			process['nextTick'](callback);
		else
			setTimeout(callback, 0);
	}

	return function pinkySwear(extend) {
		var state;           // undefined/null = pending, true = fulfilled, false = rejected
		var values = [];     // an array of values as arguments for the then() handlers
		var deferred = [];   // functions to call when set() is invoked

		var set = function(newState, newValues) {
			if (state == null && newState != null) {
				state = newState;
				values = newValues;
				if (deferred.length)
					defer(function() {
						for (var i = 0; i < deferred.length; i++)
							deferred[i]();
					});
			}
			return state;
		};

		set['then'] = function (onFulfilled, onRejected) {
			var promise2 = pinkySwear(extend);
			var callCallbacks = function() {
	    		try {
	    			var f = (state ? onFulfilled : onRejected);
	    			if (isFunction(f)) {
		   				function resolve(x) {
						    var then, cbCalled = 0;
		   					try {
				   				if (x && (isObject(x) || isFunction(x)) && isFunction(then = x['then'])) {
										if (x === promise2)
											throw new TypeError();
										then['call'](x,
											function() { if (!cbCalled++) resolve.apply(undef,arguments); } ,
											function(value){ if (!cbCalled++) promise2(false,[value]);});
				   				}
				   				else
				   					promise2(true, arguments);
		   					}
		   					catch(e) {
		   						if (!cbCalled++)
		   							promise2(false, [e]);
		   					}
		   				}
		   				resolve(f.apply(undef, values || []));
		   			}
		   			else
		   				promise2(state, values);
				}
				catch (e) {
					promise2(false, [e]);
				}
			};
			if (state != null)
				defer(callCallbacks);
			else
				deferred.push(callCallbacks);
			return promise2;
		};
        if(extend){
            set = extend(set);
        }
		return set;
	};
}));


/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(8).setImmediate, __webpack_require__(1)))

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

var apply = Function.prototype.apply;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, window, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, window, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(window, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// setimmediate attaches itself to the global object
__webpack_require__(9);
exports.setImmediate = setImmediate;
exports.clearImmediate = clearImmediate;


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
      // Callback can either be a function or a string
      if (typeof callback !== "function") {
        callback = new Function("" + callback);
      }
      // Copy function arguments
      var args = new Array(arguments.length - 1);
      for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i + 1];
      }
      // Store and register the task
      var task = { callback: callback, args: args };
      tasksByHandle[nextHandle] = task;
      registerImmediate(nextHandle);
      return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
        case 0:
            callback();
            break;
        case 1:
            callback(args[0]);
            break;
        case 2:
            callback(args[0], args[1]);
            break;
        case 3:
            callback(args[0], args[1], args[2]);
            break;
        default:
            callback.apply(undefined, args);
            break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            process.nextTick(function () { runIfPresent(handle); });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global &&
                typeof event.data === "string" &&
                event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();

    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();

    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();

    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();

    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(10), __webpack_require__(1)))

/***/ }),
/* 10 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
 * @preserve jquery-param (c) 2015 KNOWLEDGECODE | MIT
 */
/*global define */
(function (global) {
    'use strict';

    var param = function (a) {
        var add = function (s, k, v) {
            v = typeof v === 'function' ? v() : v === null ? '' : v === undefined ? '' : v;
            s[s.length] = encodeURIComponent(k) + '=' + encodeURIComponent(v);
        }, buildParams = function (prefix, obj, s) {
            var i, len, key;

            if (Object.prototype.toString.call(obj) === '[object Array]') {
                for (i = 0, len = obj.length; i < len; i++) {
                    buildParams(prefix + '[' + (typeof obj[i] === 'object' ? i : '') + ']', obj[i], s);
                }
            } else if (obj && obj.toString() === '[object Object]') {
                for (key in obj) {
                    if (obj.hasOwnProperty(key)) {
                        if (prefix) {
                            buildParams(prefix + '[' + key + ']', obj[key], s, add);
                        } else {
                            buildParams(key, obj[key], s, add);
                        }
                    }
                }
            } else if (prefix) {
                add(s, prefix, obj);
            } else {
                for (key in obj) {
                    add(s, key, obj[key]);
                }
            }
            return s;
        };
        return buildParams('', a, []).join('&').replace(/%20/g, '+');
    };

    if (typeof module === 'object' && typeof module.exports === 'object') {
        module.exports = param;
    } else if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
            return param;
        }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else {
        global.param = param;
    }

}(this));


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * @author Toru Nagashima
 * @copyright 2015 Toru Nagashima. All rights reserved.
 * See LICENSE file in root directory for full license.
 */


//-----------------------------------------------------------------------------
// Requirements
//-----------------------------------------------------------------------------

var Commons = __webpack_require__(0)
var LISTENERS = Commons.LISTENERS
var ATTRIBUTE = Commons.ATTRIBUTE
var newNode = Commons.newNode

//-----------------------------------------------------------------------------
// Helpers
//-----------------------------------------------------------------------------

/**
 * Gets a specified attribute listener from a given EventTarget object.
 *
 * @param {EventTarget} eventTarget - An EventTarget object to get.
 * @param {string} type - An event type to get.
 * @returns {function|null} The found attribute listener.
 */
function getAttributeListener(eventTarget, type) {
    var node = eventTarget[LISTENERS][type]
    while (node != null) {
        if (node.kind === ATTRIBUTE) {
            return node.listener
        }
        node = node.next
    }
    return null
}

/**
 * Sets a specified attribute listener to a given EventTarget object.
 *
 * @param {EventTarget} eventTarget - An EventTarget object to set.
 * @param {string} type - An event type to set.
 * @param {function|null} listener - A listener to be set.
 * @returns {void}
 */
function setAttributeListener(eventTarget, type, listener) {
    if (typeof listener !== "function" && typeof listener !== "object") {
        listener = null // eslint-disable-line no-param-reassign
    }

    var prev = null
    var node = eventTarget[LISTENERS][type]
    while (node != null) {
        if (node.kind === ATTRIBUTE) {
            // Remove old value.
            if (prev == null) {
                eventTarget[LISTENERS][type] = node.next
            }
            else {
                prev.next = node.next
            }
        }
        else {
            prev = node
        }

        node = node.next
    }

    // Add new value.
    if (listener != null) {
        if (prev == null) {
            eventTarget[LISTENERS][type] = newNode(listener, ATTRIBUTE)
        }
        else {
            prev.next = newNode(listener, ATTRIBUTE)
        }
    }
}

//-----------------------------------------------------------------------------
// Public Interface
//-----------------------------------------------------------------------------

/**
 * Defines an `EventTarget` implementation which has `onfoobar` attributes.
 *
 * @param {EventTarget} EventTargetBase - A base implementation of EventTarget.
 * @param {string[]} types - A list of event types which are defined as attribute listeners.
 * @returns {EventTarget} The defined `EventTarget` implementation which has attribute listeners.
 */
module.exports.defineCustomEventTarget = function(EventTargetBase, types) {
    /**
     * The constructor of custom event target.
     * @constructor
     */
    function EventTarget() {
        EventTargetBase.call(this)
    }

    var descripter = {
        constructor: {
            value: EventTarget,
            configurable: true,
            writable: true,
        },
    }

    types.forEach(function(type) {
        descripter["on" + type] = {
            get: function() {
                return getAttributeListener(this, type)
            },
            set: function(listener) {
                setAttributeListener(this, type, listener)
            },
            configurable: true,
            enumerable: true,
        }
    })

    EventTarget.prototype = Object.create(EventTargetBase.prototype, descripter)

    return EventTarget
}


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * @author Toru Nagashima
 * @copyright 2015 Toru Nagashima. All rights reserved.
 * See LICENSE file in root directory for full license.
 */


//-----------------------------------------------------------------------------
// Requirements
//-----------------------------------------------------------------------------

var createUniqueKey = __webpack_require__(0).createUniqueKey

//-----------------------------------------------------------------------------
// Constsnts
//-----------------------------------------------------------------------------

/**
 * The key of the flag which is turned on by `stopImmediatePropagation` method.
 *
 * @type {symbol|string}
 * @private
 */
var STOP_IMMEDIATE_PROPAGATION_FLAG =
    createUniqueKey("stop_immediate_propagation_flag")

/**
 * The key of the flag which is turned on by `preventDefault` method.
 *
 * @type {symbol|string}
 * @private
 */
var CANCELED_FLAG = createUniqueKey("canceled_flag")

/**
 * The key of the flag that it cannot use `preventDefault` method.
 *
 * @type {symbol|string}
 * @private
 */
var PASSIVE_LISTENER_FLAG = createUniqueKey("passive_listener_flag")

/**
 * The key of the original event object.
 *
 * @type {symbol|string}
 * @private
 */
var ORIGINAL_EVENT = createUniqueKey("original_event")

/**
 * Method definitions for the event wrapper.
 *
 * @type {object}
 * @private
 */
var wrapperPrototypeDefinition = Object.freeze({
    stopPropagation: Object.freeze({
        value: function stopPropagation() {
            var e = this[ORIGINAL_EVENT]
            if (typeof e.stopPropagation === "function") {
                e.stopPropagation()
            }
        },
        writable: true,
        configurable: true,
    }),

    stopImmediatePropagation: Object.freeze({
        value: function stopImmediatePropagation() {
            this[STOP_IMMEDIATE_PROPAGATION_FLAG] = true

            var e = this[ORIGINAL_EVENT]
            if (typeof e.stopImmediatePropagation === "function") {
                e.stopImmediatePropagation()
            }
        },
        writable: true,
        configurable: true,
    }),

    preventDefault: Object.freeze({
        value: function preventDefault() {
            if (this[PASSIVE_LISTENER_FLAG]) {
                return
            }
            if (this.cancelable === true) {
                this[CANCELED_FLAG] = true
            }

            var e = this[ORIGINAL_EVENT]
            if (typeof e.preventDefault === "function") {
                e.preventDefault()
            }
        },
        writable: true,
        configurable: true,
    }),

    defaultPrevented: Object.freeze({
        get: function defaultPrevented() {
            return this[CANCELED_FLAG]
        },
        enumerable: true,
        configurable: true,
    }),
})

//-----------------------------------------------------------------------------
// Public Interface
//-----------------------------------------------------------------------------

module.exports.STOP_IMMEDIATE_PROPAGATION_FLAG = STOP_IMMEDIATE_PROPAGATION_FLAG
module.exports.PASSIVE_LISTENER_FLAG = PASSIVE_LISTENER_FLAG

/**
 * Creates an event wrapper.
 *
 * We cannot modify several properties of `Event` object, so we need to create the wrapper.
 * Plus, this wrapper supports non `Event` objects.
 *
 * @param {Event|{type: string}} event - An original event to create the wrapper.
 * @param {EventTarget} eventTarget - The event target of the event.
 * @returns {Event} The created wrapper. This object is implemented `Event` interface.
 * @private
 */
module.exports.createEventWrapper = function createEventWrapper(event, eventTarget) {
    var timeStamp = (
        typeof event.timeStamp === "number" ? event.timeStamp : Date.now()
    )
    var propertyDefinition = {
        type: {value: event.type, enumerable: true},
        target: {value: eventTarget, enumerable: true},
        currentTarget: {value: eventTarget, enumerable: true},
        eventPhase: {value: 2, enumerable: true},
        bubbles: {value: Boolean(event.bubbles), enumerable: true},
        cancelable: {value: Boolean(event.cancelable), enumerable: true},
        timeStamp: {value: timeStamp, enumerable: true},
        isTrusted: {value: false, enumerable: true},
    }
    propertyDefinition[STOP_IMMEDIATE_PROPAGATION_FLAG] = {value: false, writable: true}
    propertyDefinition[CANCELED_FLAG] = {value: false, writable: true}
    propertyDefinition[PASSIVE_LISTENER_FLAG] = {value: false, writable: true}
    propertyDefinition[ORIGINAL_EVENT] = {value: event}

    // For CustomEvent.
    if (typeof event.detail !== "undefined") {
        propertyDefinition.detail = {value: event.detail, enumerable: true}
    }

    return Object.create(
        Object.create(event, wrapperPrototypeDefinition),
        propertyDefinition
    )
}


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var matchesMethodName = 'matches' in Element.prototype ? 'matches' : 'msMatchesSelector';

var UIHandler = function () {
	function UIHandler(naja) {
		_classCallCheck(this, UIHandler);

		this.selector = '.ajax';
		this.allowedOrigins = [];

		this.naja = naja;

		this.handler = this.handleUI.bind(this);
		naja.addEventListener('init', this.initialize.bind(this));

		// window.location.origin is not supported in IE 10
		var origin = window.location.protocol + '//' + window.location.hostname + (window.location.port ? ':' + window.location.port : '');
		this.allowedOrigins.push(origin);
	}

	_createClass(UIHandler, [{
		key: 'initialize',
		value: function initialize() {
			var _this = this;

			this.bindUI(window.document.body);
			this.naja.snippetHandler.addEventListener('afterUpdate', function (_ref) {
				var snippet = _ref.snippet;

				_this.bindUI(snippet);
			});
		}
	}, {
		key: 'bindUI',
		value: function bindUI(element) {
			var _this2 = this;

			var selectors = ['a' + this.selector, 'input[type="submit"]' + this.selector, 'input[type="image"]' + this.selector, 'button[type="submit"]' + this.selector, 'form' + this.selector + ' input[type="submit"]', 'form' + this.selector + ' input[type="image"]', 'form' + this.selector + ' button[type="submit"]'].join(', ');

			var bindElement = function bindElement(element) {
				element.removeEventListener('click', _this2.handler);
				element.addEventListener('click', _this2.handler);
			};

			var elements = element.querySelectorAll(selectors);
			for (var i = 0; i < elements.length; i++) {
				bindElement(elements.item(i));
			}

			if (element[matchesMethodName](selectors)) {
				bindElement(element);
			}

			var bindForm = function bindForm(form) {
				form.removeEventListener('submit', _this2.handler);
				form.addEventListener('submit', _this2.handler);
			};

			if (element[matchesMethodName]('form' + this.selector)) {
				bindForm(element);
			}

			var forms = element.querySelectorAll('form' + this.selector);
			for (var _i = 0; _i < forms.length; _i++) {
				bindForm(forms.item(_i));
			}
		}
	}, {
		key: 'handleUI',
		value: function handleUI(evt) {
			if (evt.altKey || evt.ctrlKey || evt.shiftKey || evt.metaKey || evt.button) {
				return;
			}

			var el = evt.currentTarget,
			    options = {};

			if (evt.type === 'submit') {
				this.submitForm(el, options, evt);
			} else if (evt.type === 'click') {
				this.clickElement(el, options, evt);
			}
		}
	}, {
		key: 'clickElement',
		value: function clickElement(el) {
			var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
			var evt = arguments[2];

			var method = void 0,
			    url = void 0,
			    data = void 0;

			if (!this.naja.fireEvent('interaction', { element: el, originalEvent: evt, options: options })) {
				if (evt) {
					evt.preventDefault();
				}

				return;
			}

			if (el.tagName.toLowerCase() === 'a') {
				method = 'GET';
				url = el.href;
				data = null;
			} else if (el.tagName.toLowerCase() === 'input' || el.tagName.toLowerCase() === 'button') {
				var form = el.form;

				method = form.method ? form.method.toUpperCase() : 'GET';
				url = form.action || window.location.pathname + window.location.search;
				data = new FormData(form);

				if (el.type === 'submit' || el.tagName.toLowerCase() === 'button') {
					data.append(el.name, el.value || '');
				} else if (el.type === 'image') {
					var coords = el.getBoundingClientRect();
					data.append(el.name + '.x', Math.max(0, Math.floor(evt.pageX - coords.left)));
					data.append(el.name + '.y', Math.max(0, Math.floor(evt.pageY - coords.top)));
				}
			}

			if (this.isUrlAllowed(url)) {
				if (evt) {
					evt.preventDefault();
				}

				this.naja.makeRequest(method, url, data, options);
			}
		}
	}, {
		key: 'submitForm',
		value: function submitForm(form) {
			var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
			var evt = arguments[2];

			if (!this.naja.fireEvent('interaction', { element: form, originalEvent: evt, options: options })) {
				if (evt) {
					evt.preventDefault();
				}

				return;
			}

			var method = form.method ? form.method.toUpperCase() : 'GET';
			var url = form.action || window.location.pathname + window.location.search;
			var data = new FormData(form);

			if (this.isUrlAllowed(url)) {
				if (evt) {
					evt.preventDefault();
				}

				this.naja.makeRequest(method, url, data, options);
			}
		}
	}, {
		key: 'isUrlAllowed',
		value: function isUrlAllowed(url) {
			// ignore non-URL URIs (javascript:, data:, ...)
			if (/^(?!https?)[^:/?#]+:/i.test(url)) {
				return false;
			}

			return !/^https?/i.test(url) || this.allowedOrigins.some(function (origin) {
				return new RegExp('^' + origin, 'i').test(url);
			});
		}
	}]);

	return UIHandler;
}();

exports.default = UIHandler;

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var FormsHandler = function () {
	function FormsHandler(naja) {
		_classCallCheck(this, FormsHandler);

		this.naja = naja;

		naja.addEventListener('init', this.initialize.bind(this));
		naja.addEventListener('interaction', this.processForm.bind(this));
	}

	_createClass(FormsHandler, [{
		key: 'initialize',
		value: function initialize() {
			var _this = this;

			this.initForms(window.document.body);
			this.naja.snippetHandler.addEventListener('afterUpdate', function (_ref) {
				var snippet = _ref.snippet;

				_this.initForms(snippet);
			});
		}
	}, {
		key: 'initForms',
		value: function initForms(element) {
			var netteForms = this.netteForms || window.Nette;
			if (netteForms) {
				if (element.tagName === 'form') {
					netteForms.initForm(element);
				}

				var forms = element.querySelectorAll('form');
				for (var i = 0; i < forms.length; i++) {
					netteForms.initForm(forms.item(i));
				}
			}
		}
	}, {
		key: 'processForm',
		value: function processForm(evt) {
			var element = evt.element,
			    originalEvent = evt.originalEvent;


			if (element.form) {
				element.form['nette-submittedBy'] = element;
			}

			var netteForms = this.netteForms || window.Nette;
			if ((element.tagName === 'form' || element.form) && netteForms && !netteForms.validateForm(element)) {
				if (originalEvent) {
					originalEvent.stopImmediatePropagation();
					originalEvent.preventDefault();
				}

				evt.preventDefault();
			}
		}
	}]);

	return FormsHandler;
}();

exports.default = FormsHandler;

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var RedirectHandler = function () {
	function RedirectHandler(naja) {
		var _this = this;

		_classCallCheck(this, RedirectHandler);

		this.naja = naja;

		naja.addEventListener('success', function (evt) {
			var response = evt.response,
			    options = evt.options;

			if (response.redirect) {
				_this.makeRedirect(response.redirect, response.forceRedirect || options.forceRedirect);
				evt.stopImmediatePropagation();
			}
		});

		this.locationAdapter = {
			assign: function assign(url) {
				return window.location.assign(url);
			}
		};
	}

	_createClass(RedirectHandler, [{
		key: 'makeRedirect',
		value: function makeRedirect(url, force) {
			// window.location.origin is not supported in IE 10
			var origin = window.location.protocol + '//' + window.location.hostname + (window.location.port ? ':' + window.location.port : '');
			var externalRedirect = /^https?/i.test(url) && !new RegExp('^' + origin, 'i').test(url);
			if (force || externalRedirect) {
				this.locationAdapter.assign(url);
			} else {
				this.naja.makeRequest('GET', url);
			}
		}
	}]);

	return RedirectHandler;
}();

exports.default = RedirectHandler;

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _eventTargetShim = __webpack_require__(2);

var _eventTargetShim2 = _interopRequireDefault(_eventTargetShim);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SnippetHandler = function (_EventTarget) {
	_inherits(SnippetHandler, _EventTarget);

	function SnippetHandler(naja) {
		_classCallCheck(this, SnippetHandler);

		var _this = _possibleConstructorReturn(this, (SnippetHandler.__proto__ || Object.getPrototypeOf(SnippetHandler)).call(this));

		naja.addEventListener('success', function (_ref) {
			var response = _ref.response;

			if (response.snippets) {
				_this.updateSnippets(response.snippets);
			}
		});
		return _this;
	}

	_createClass(SnippetHandler, [{
		key: 'updateSnippets',
		value: function updateSnippets(snippets) {
			var _this2 = this;

			var forceReplace = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

			Object.keys(snippets).forEach(function (id) {
				var el = document.getElementById(id);
				if (el) {
					_this2.updateSnippet(el, snippets[id], forceReplace);
				}
			});
		}
	}, {
		key: 'updateSnippet',
		value: function updateSnippet(el, content, forceReplace) {
			var canUpdate = this.dispatchEvent({
				type: 'beforeUpdate',
				cancelable: true,
				snippet: el,
				content: content
			});

			if (!canUpdate) {
				return;
			}

			if (el.tagName.toLowerCase() === 'title') {
				document.title = content;
			} else {
				if ((el.hasAttribute('data-naja-snippet-prepend') || el.hasAttribute('data-ajax-prepend')) && !forceReplace) {
					el.insertAdjacentHTML('afterbegin', content);
				} else if ((el.hasAttribute('data-naja-snippet-append') || el.hasAttribute('data-ajax-append')) && !forceReplace) {
					el.insertAdjacentHTML('beforeend', content);
				} else {
					el.innerHTML = content;
				}
			}

			this.dispatchEvent({
				type: 'afterUpdate',
				cancelable: true,
				snippet: el,
				content: content
			});
		}
	}]);

	return SnippetHandler;
}(_eventTargetShim2.default);

exports.default = SnippetHandler;

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var HistoryHandler = function () {
	function HistoryHandler(naja) {
		_classCallCheck(this, HistoryHandler);

		this.href = null;
		this.uiCache = true;

		this.naja = naja;

		naja.addEventListener('init', this.initialize.bind(this));
		naja.addEventListener('interaction', this.configureMode.bind(this));
		naja.addEventListener('before', this.saveUrl.bind(this));
		naja.addEventListener('success', this.pushNewState.bind(this));

		this.popStateHandler = this.handlePopState.bind(this);
		this.historyAdapter = {
			replaceState: function replaceState(data, title, url) {
				return window.history.replaceState(data, title, url);
			},
			pushState: function pushState(data, title, url) {
				return window.history.pushState(data, title, url);
			}
		};
	}

	_createClass(HistoryHandler, [{
		key: 'initialize',
		value: function initialize() {
			window.addEventListener('popstate', this.popStateHandler);
			this.historyAdapter.replaceState(this.buildState(window.location.href, this.uiCache), window.document.title, window.location.href);
		}
	}, {
		key: 'handlePopState',
		value: function handlePopState(e) {
			if (!e.state) {
				return;
			}

			if (e.state.ui) {
				this.handleSnippets(e.state.ui);
				this.handleTitle(e.state.title);
			} else if (e.state.ui === false) {
				this.naja.makeRequest('GET', e.state.href, null, {
					history: false,
					historyUiCache: false
				});
			}
		}
	}, {
		key: 'saveUrl',
		value: function saveUrl(_ref) {
			var url = _ref.url;

			this.href = url;
		}
	}, {
		key: 'configureMode',
		value: function configureMode(_ref2) {
			var element = _ref2.element,
			    options = _ref2.options;

			// propagate mode to options
			if (!element) {
				return;
			}

			if (element.hasAttribute('data-naja-history')) {
				options.history = this.constructor.normalizeMode(element.getAttribute('data-naja-history'));
			}

			if (element.hasAttribute('data-naja-history-cache')) {
				options.historyUiCache = element.getAttribute('data-naja-history-cache') !== 'off';
			}
		}
	}, {
		key: 'pushNewState',
		value: function pushNewState(_ref3) {
			var response = _ref3.response,
			    options = _ref3.options;

			var mode = this.constructor.normalizeMode(options.history);
			if (mode === false) {
				return;
			}

			if (response.postGet && response.url) {
				this.href = response.url;
			}

			var method = response.replaceHistory || mode === 'replace' ? 'replaceState' : 'pushState';
			var uiCache = options.historyUiCache === true || options.historyUiCache !== false && this.uiCache; // eslint-disable-line no-extra-parens
			this.historyAdapter[method](this.buildState(this.href, uiCache), window.document.title, this.href);

			this.href = null;
		}
	}, {
		key: 'buildState',
		value: function buildState(href, uiCache) {
			var state = {
				href: href
			};

			if (uiCache) {
				state.title = window.document.title;
				state.ui = this.findSnippets();
			} else {
				state.ui = false;
			}

			return state;
		}
	}, {
		key: 'findSnippets',
		value: function findSnippets() {
			var result = {};
			var snippets = window.document.querySelectorAll('[id^="snippet-"]');
			for (var i = 0; i < snippets.length; i++) {
				var snippet = snippets.item(i);
				if (!snippet.hasAttribute('data-naja-history-nocache') && !snippet.hasAttribute('data-history-nocache')) {
					result[snippet.id] = snippet.innerHTML;
				}
			}

			return result;
		}
	}, {
		key: 'handleSnippets',
		value: function handleSnippets(snippets) {
			this.naja.snippetHandler.updateSnippets(snippets, true);
			this.naja.scriptLoader.loadScripts(snippets);
			this.naja.load();
		}
	}, {
		key: 'handleTitle',
		value: function handleTitle(title) {
			window.document.title = title;
		}
	}], [{
		key: 'normalizeMode',
		value: function normalizeMode(mode) {
			if (mode === 'off' || mode === false) {
				return false;
			} else if (mode === 'replace') {
				return 'replace';
			}

			return true;
		}
	}]);

	return HistoryHandler;
}();

exports.default = HistoryHandler;

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ScriptLoader = function () {
	function ScriptLoader(naja) {
		var _this = this;

		_classCallCheck(this, ScriptLoader);

		naja.addEventListener('success', function (_ref) {
			var response = _ref.response;

			if (response.snippets) {
				_this.loadScripts(response.snippets);
			}
		});
	}

	_createClass(ScriptLoader, [{
		key: 'loadScripts',
		value: function loadScripts(snippets) {
			Object.keys(snippets).forEach(function (id) {
				var content = snippets[id];
				if (!/<script/i.test(content)) {
					return;
				}

				var el = window.document.createElement('div');
				el.innerHTML = content;

				var scripts = el.querySelectorAll('script');
				for (var i = 0; i < scripts.length; i++) {
					var script = scripts.item(i);
					var scriptEl = window.document.createElement('script');
					scriptEl.innerHTML = script.innerHTML;

					if (script.hasAttributes()) {
						var attrs = script.attributes;
						for (var j = 0; j < attrs.length; j++) {
							var attrName = attrs[j].name;
							scriptEl[attrName] = attrs[j].value;
						}
					}

					window.document.head.appendChild(scriptEl).parentNode.removeChild(scriptEl);
				}
			});
		}
	}]);

	return ScriptLoader;
}();

exports.default = ScriptLoader;

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var AbortExtension = function () {
	function AbortExtension(naja) {
		_classCallCheck(this, AbortExtension);

		this.abortable = true;
		this.xhr = null;

		naja.addEventListener('init', this.initialize.bind(this));
		naja.addEventListener('interaction', this.checkAbortable.bind(this));
		naja.addEventListener('before', this.checkAbortable.bind(this));
		naja.addEventListener('start', this.saveXhr.bind(this));
		naja.addEventListener('complete', this.clearXhr.bind(this));
	}

	_createClass(AbortExtension, [{
		key: 'initialize',
		value: function initialize() {
			var _this = this;

			document.addEventListener('keydown', function (evt) {
				if (!!_this.xhr && ('key' in evt ? evt.key === 'Escape' : evt.keyCode === 27) && !(evt.ctrlKey || evt.shiftKey || evt.altKey || evt.metaKey) && _this.abortable) {
					_this.xhr.abort();
					_this.xhr = null;
				}
			});
		}
	}, {
		key: 'checkAbortable',
		value: function checkAbortable(_ref) {
			var element = _ref.element,
			    options = _ref.options;

			this.abortable = element ? element.getAttribute('data-naja-abort') !== 'off' : options.abort !== false;

			// propagate to options if called in interaction event
			options.abort = this.abortable;
		}
	}, {
		key: 'saveXhr',
		value: function saveXhr(_ref2) {
			var xhr = _ref2.xhr;

			this.xhr = xhr;
		}
	}, {
		key: 'clearXhr',
		value: function clearXhr() {
			this.xhr = null;
			this.abortable = true;
		}
	}]);

	return AbortExtension;
}();

exports.default = AbortExtension;

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var UniqueExtension = function () {
	function UniqueExtension(naja) {
		_classCallCheck(this, UniqueExtension);

		this.xhr = null;

		naja.addEventListener('interaction', this.checkUniqueness.bind(this));
		naja.addEventListener('before', this.abortPreviousRequest.bind(this));
		naja.addEventListener('complete', this.clearRequest.bind(this));
	}

	_createClass(UniqueExtension, [{
		key: 'checkUniqueness',
		value: function checkUniqueness(_ref) {
			var element = _ref.element,
			    options = _ref.options;

			options.unique = element.getAttribute('data-naja-unique') !== 'off';
		}
	}, {
		key: 'abortPreviousRequest',
		value: function abortPreviousRequest(_ref2) {
			var xhr = _ref2.xhr,
			    options = _ref2.options;

			if (!!this.xhr && options.unique !== false) {
				this.xhr.abort();
			}

			this.xhr = xhr;
		}
	}, {
		key: 'clearRequest',
		value: function clearRequest() {
			this.xhr = null;
		}
	}]);

	return UniqueExtension;
}();

exports.default = UniqueExtension;

/***/ })
/******/ ])["default"];
});


// WEBPACK FOOTER //
// Naja.js